module.exports = __webpack_public_path__ + "img/cert4.fc7fd2ed.png";